import { useCallback, useEffect, useState } from 'react';

const KEY = 'tap.sidebar.collapsed';

/**
 * Remembered, because a sidebar that springs back open on every reload is worse than
 * one that does not collapse at all — you would be closing it several times a day.
 *
 * Only desktop reads this. The mobile drawer is always full width: an icon rail you
 * have to open a drawer to see is a rail with no reason to exist.
 */
export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem(KEY) === '1');

  useEffect(() => {
    if (collapsed) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  }, [collapsed]);

  const toggle = useCallback(() => setCollapsed((value) => !value), []);

  return { collapsed, toggle };
}
